import createReducer from 'utils/createReducer';
import { CHANGE_PASSWORD } from 'state/actionTypes';

export default createReducer(false, {
  [CHANGE_PASSWORD]: (state, { payload }) => payload,
});
